import { IResponseOfTag, ResponseCode } from "services/KnowfullyAdminClient";

// A missing tag arrives as a 200 with a NotFound response code. Without a tag the SKU lookup stays
// unfiltered rather than empty; with the tag, only SKUs carrying it are offered.
export const accessLevelTagIds = (response: IResponseOfTag | null | undefined): string[] | undefined =>
  response?.responseCode === ResponseCode.OK && response.data?.id
    ? [response.data.id]
    : undefined;
